export default {
  path: '/process_types',
  name: 'process_types',
  component: () => import('../components/processtype/Layout'),
  redirect: { name: 'ProcessTypeList' },
  meta: {
    breadcrumb: 'process.documentationtypes',
  },
  children: [
    {
      name: 'ProcessTypeList',
      path: '',
      component: () => import('../views/processtype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProcessTypeCreate',
      path: 'new',
      component: () => import('../views/processtype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProcessTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/processtype/Update'),
      meta: {
        breadcrumb: 'process.documentationtype',
      },
    },
    {
      name: 'ProcessTypeShow',
      path: ':id',
      component: () => import('../views/processtype/Show'),
      meta: {
        breadcrumb: 'process.documentationtype',
      },
    }
  ]
};
